<div class="col-md-12">
  <button class="btn border mb-2" (click)="clearFilter(listbox)">Rensa</button>
      
  <div class="row">
    <div class="col-md-6">
      <!--p-listbox #listbox [options]="institutionlist" [(ngModel)]="selectedinstitutions" [multiple]="true" showClear="true" [checkbox]="true" [filter]="true" optionLabel="name" [listStyle]="{'max-height':'200px'}" [style]="{'width':'100%'}" (onChange)="updateSelectedInstitutions($event)"
        (click)="clearFilter(listbox)">
        <p-header>
          <span>Institutioner
            <button class="btn border pull-right" (click)="selectedinstitutions=[];updateSelectedInstitutions($event)" title="Rensa filter" style="font-family: Verdana, Geneva, Tahoma, sans-serif;">Rensa</button></span>
        </p-header>
      </p-listbox-->

      <p-multiselect #listbox [options]="institutionlist" appendTo="body" showClear="true" [filter]="true" [(ngModel)]="selectedinstitutions" optionLabel="name" (onChange)="updateSelectedInstitutions($event)" [style]="{'width':'100%'}">
      </p-multiselect>

      <div style="max-height:300px;overflow-y: auto;" class="mt-2">
        <table style="border:1px solid lightgrey;border-radius:3px;width:100%;">
          <tr *ngFor="let x of selectedinstitutions">
            <td>{{x.name}}</td>
            <td align="right"><i class="fa fa-times" (click)="removeSelectedInstitution(x.id);" title="Ta bort vald institution"></i></td>
          </tr>
        </table>
      </div>
      <br><br>
    </div>
    <div class="col-md-6">
      <form [formGroup]="form">

        <label for="institutionTypeId">Institutionstyp</label>
        <select class="form-control form-control-sm" id="institutionTypeId" formControlName="institutionTypeId" (change)="onChangeInstitutionType($event)">
          <option></option>
          <option *ngFor="let inst of institutiontypes" [value]="inst.id">{{inst.prefix}} - {{inst.name}}</option>
        </select>

        <label for="parentInstitutionId">
          Tillhör distrikt o dyl
        </label>
        <select #district class="form-control form-control-sm" id="parentInstitutionId" formControlName="parentInstitutionId" (change)="updateInstitutionList($event)">
          <option></option>
          <option *ngFor="let d of districtlist" [value]="d.id">{{d.shortName}} - {{d.name}}</option>
        </select>
      </form>
      <!--p-listbox [options]="institutionbydistrictlist" [(ngModel)]="selectedinstitutions" [multiple]="true" [checkbox]="true" [filter]="false" optionLabel="name" [listStyle]="{'max-height':'200px'}" [style]="{'width':'340px'}" (onChange)="updateSelectedInstitutions($event)">
      </p-listbox-->
      <p-multiselect *ngIf="form.get('parentInstitutionId')?.value" [options]="institutionbydistrictlist" [(ngModel)]="selectedinstitutions" appendTo="body" [showClear]="true" [filter]="false" optionLabel="name" [listStyle]="{'max-height':'200px'}" [style]="{'width':'340px'}" (onChange)="updateSelectedInstitutions($event)">
      </p-multiselect>
    
    </div>
  </div>
</div>